import { Storage } from '@trello/storage';
import { State } from 'app/gamma/src/modules/types';
import { Store } from 'redux';
import { getMyId } from 'app/gamma/src/selectors/session';

const STORAGE_KEY = 'idMe';

export const saveLastSession = (store: Store<State>) => {
  let idLast: string | undefined = undefined;

  const update = () => {
    const state = store.getState();
    const idMe = getMyId(state);

    if (idMe && idLast !== idMe) {
      idLast = idMe;
      Storage.set(STORAGE_KEY, idMe);
    }
  };

  // use mousedown events to mean "this is the most recent session"
  document.addEventListener('mousedown', update);

  // Watch out of a change that causes the token to get set or unset
  store.subscribe(update);
};

export const getLastMemberId = () => {
  return Storage.get(STORAGE_KEY);
};

export const getLastToken = () => {
  return Storage.get('token');
};
